import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import getNotifications from "notifications/helpers/getNotifications";
import useWindowSize from "syf-component-library/ui/customHooks/useWindowWidth";
import { DesktopCard } from "../DesktopCard";
import { MobileCard } from "../MobileCard";
var CardLayout = function (_a) {
    var notificationsObject = _a.notificationsObject, cardData = _a.cardData;
    var windowWidth = useWindowSize();
    var _b = useState(false), isFlipped = _b[0], setIsFlipped = _b[1];
    var notificationsList = notificationsObject
        ? getNotifications(notificationsObject)
        : undefined;
    return !windowWidth.isLessThanMobile ? (_jsx(DesktopCard, { notificationList: notificationsList, cardData: cardData, isFlipped: isFlipped, setIsFlipped: setIsFlipped })) : (_jsx(MobileCard, { notificationList: notificationsList, cardData: cardData, isFlipped: isFlipped, setIsFlipped: setIsFlipped }));
};
export default CardLayout;
//# sourceMappingURL=CardLayout.js.map